module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett2-e99f29e4dd2d873117775c7ec1912d48.jpg";